var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DateField, DateCalendar, } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import TextField from "../TextField";
import IconButton from "../../IconButton";
import { datepickerStyles } from "./Datepicker.styles";
import { Box, ClickAwayListener, Grow, Paper, Popper, } from "@mui/material";
var DatePicker = function (_a) {
    var _b = _a.dateFieldProps, dateFieldProps = _b === void 0 ? {} : _b, _c = _a.calendarProps, calendarProps = _c === void 0 ? {} : _c, sx = _a.sx;
    var onChange = dateFieldProps.onChange, value = dateFieldProps.value, error = dateFieldProps.error, disabled = dateFieldProps.disabled, dateFieldSlotProps = dateFieldProps.slotProps, _d = dateFieldProps.defaultValue, defaultValue = _d === void 0 ? null : _d, _e = dateFieldProps.format, format = _e === void 0 ? "MM/DD/YYYY" : _e, restDateFieldProps = __rest(dateFieldProps, ["onChange", "value", "error", "disabled", "slotProps", "defaultValue", "format"]);
    var _f = calendarProps.showDaysOutsideCurrentMonth, showDaysOutsideCurrentMonth = _f === void 0 ? true : _f, calendarSlotProps = calendarProps.slotProps, restCalendarProps = __rest(calendarProps, ["showDaysOutsideCurrentMonth", "slotProps"]);
    var inputRef = useRef(null);
    var _g = __read(useState(null), 2), anchorEl = _g[0], setAnchorEl = _g[1];
    var _h = __read(useState(defaultValue), 2), localValue = _h[0], setValue = _h[1];
    var _j = __read(useState("day"), 2), view = _j[0], setView = _j[1];
    // uncontrolled vs controlled
    var valueToUse = value || localValue;
    var open = Boolean(anchorEl);
    var handleLocalChange = function (newValue) {
        setValue(newValue);
    };
    // uncontrolled vs controlled
    var handleChange = onChange || handleLocalChange;
    var handleCalendarChange = function (val, selectionState) {
        // dont update and close if its just a month selection
        if (selectionState === "finish") {
            onClose();
            handleChange(val, { validationError: null });
        }
    };
    // mui datepicker doesnt have next/previous year functionality, fake it via these 2 fns
    var nextYear = function () {
        var dayjsObj = valueToUse || dayjs();
        handleChange(dayjsObj.add(1, "year"), { validationError: null });
    };
    var previousYear = function () {
        var dayjsObj = valueToUse || dayjs();
        handleChange(dayjsObj.subtract(1, "year"), { validationError: null });
    };
    /**
     * On input click, open popover
     */
    var onInputClick = function (e) {
        var _a, _b;
        if ((_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.contains("MuiInputBase-input")) {
            openDropdown();
        }
    };
    /**
     * open dropdown of time options
     */
    var openDropdown = function () {
        setAnchorEl(inputRef === null || inputRef === void 0 ? void 0 : inputRef.current);
    };
    /**
     * When clear is selected, trigger change event with null data
     */
    var clear = function () {
        handleChange(null, { validationError: null });
    };
    /**
     * To allow user to type in input, we need to control the open/close
     */
    var onClose = function () {
        setAnchorEl(null);
    };
    return (_jsx(ClickAwayListener, __assign({ onClickAway: onClose }, { children: _jsx(Box, __assign({ sx: sx }, { children: _jsxs(LocalizationProvider, __assign({ dateAdapter: AdapterDayjs }, { children: [_jsx(DateField, __assign({ format: format, value: valueToUse, onChange: handleChange, slotProps: __assign(__assign({}, dateFieldSlotProps), { textField: __assign({ onClick: onInputClick, inputRef: inputRef, endAdornmentClick: valueToUse ? clear : openDropdown, error: error, endAdornment: valueToUse ? (_jsx(ClearIcon, {})) : (_jsx(CalendarMonthIcon, {})) }, dateFieldSlotProps === null || dateFieldSlotProps === void 0 ? void 0 : dateFieldSlotProps.textField) }), slots: {
                            textField: TextField,
                        }, disabled: disabled }, restDateFieldProps)), _jsx(Popper, __assign({ open: open && !disabled, anchorEl: anchorEl, placement: "bottom-start", transition: true, sx: {
                            pt: 2.5,
                            zIndex: 1300,
                        } }, { children: function (_a) {
                            var TransitionProps = _a.TransitionProps;
                            return (_jsx(Grow, __assign({}, TransitionProps, { timeout: 200 }, { children: _jsx(Paper, __assign({ sx: datepickerStyles }, { children: _jsx(DateCalendar, __assign({ value: valueToUse, onChange: handleCalendarChange, onViewChange: setView, dayOfWeekFormatter: function (day) { return day; }, slotProps: __assign(__assign({}, calendarSlotProps), { day: {
                                                tabIndex: 2,
                                            } }), showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, views: ["month", "day"], slots: {
                                            // hide switch view button
                                            switchViewButton: function () { return _jsx("div", {}); },
                                            // customize click event on next button based on if in month view or day
                                            nextIconButton: function (_a) {
                                                var _ownerState = _a.ownerState, _size = _a.size, defaultOnClick = _a.onClick, children = _a.children, rest = __rest(_a, ["ownerState", "size", "onClick", "children"]);
                                                var onClick = view === "day" ? defaultOnClick : nextYear;
                                                return (_jsx(IconButton, __assign({}, rest, { onClick: onClick, "data-testid": view === "day" ? "btn-nextMonth" : "btn-nextYear" }, { children: children })));
                                            },
                                            // customize click event on next button based on if in month view or day
                                            previousIconButton: function (_a) {
                                                var _ownerState = _a.ownerState, _size = _a.size, defaultOnClick = _a.onClick, children = _a.children, rest = __rest(_a, ["ownerState", "size", "onClick", "children"]);
                                                var onClick = view === "day" ? defaultOnClick : previousYear;
                                                return (_jsx(IconButton, __assign({}, rest, { onClick: onClick, "data-testid": view === "day"
                                                        ? "btn-previousMonth"
                                                        : "btn-previousYear" }, { children: children })));
                                            },
                                        }, disabled: disabled }, restCalendarProps)) })) })));
                        } }))] })) })) })));
};
export default DatePicker;
